import { z } from 'zod';

/**
 * Schema for the delete test DLNs request payload
 */
export const zodDeleteTestDlnsRequestSchema = z.object({
  /**
   * Company/buyer ID (UUID format)
   */
  buyerId: z.uuid(),
  /**
   * Whether this is a dry run (count only) or actual deletion
   * Default: true (dry run)
   */
  dryRun: z.boolean().prefault(true),
});

/**
 * Schema for the delete test DLNs response
 */
export const zodDeleteTestDlnsResponseSchema = z.object({
  /**
   * Number of main chains that would be/were affected
   */
  countChains: z.int().min(0),
  /**
   * Number of main DLNs that would be/were affected
   */
  countMains: z.int().min(0),
});
